import { AnyAction, combineReducers } from 'redux';
import { FetchStatus } from '../appState';

type AlcopaAccessState = { isActif: boolean; status: FetchStatus };

const initialState: { access: AlcopaAccessState; updateAccessStatus: FetchStatus } = {
    access: { isActif: false, status: 'idle' },
    updateAccessStatus: 'idle',
};

export const updateAccessStatus = (state: FetchStatus = 'idle', action: AnyAction): FetchStatus => {
    if (action.type === 'user/updateAlcopaAccessRequested') return 'loading';
    if (action.type === 'user/updateAlcopaAccessFailed') return 'failed';
    if (action.type === 'user/updateAlcopaAccessSucceeded') return 'succeeded';
    return state;
};

export const access = (state = initialState.access, action: AnyAction): AlcopaAccessState => {
    if (action.type === 'user/getAlcopaAccessRequested') {
        return {
            ...state,
            status: 'loading',
        };
    }
    if (action.type === 'user/getAlcopaAccessSucceeded') {
        return {
            isActif: action.payload?.isActif,
            status: 'succeeded',
        };
    }
    return state;
};

export const alcopaReducer = combineReducers({
    updateAccessStatus,
    access,
});
